<template>
  <ui-smart-link :to="props.to">
    <slot />
  </ui-smart-link>
</template>

<script lang="ts" setup>
import {
  h,
  useSlots,
  useAttrs,
  resolveComponent,
  getCurrentInstance,
  type Component,
  type ConcreteComponent,
} from 'vue'

interface Props {
  to: string | object
}

const props = defineProps<Props>()
const slots = useSlots()
const attrs = useAttrs()

const ctx = getCurrentInstance()?.appContext

// Vue router sets $router as a global property
const router = ctx?.config.globalProperties?.$router

// $nuxt is injected in vue app instance and in global properties ref - https://github.com/nuxt/nuxt/blob/efae7e2b210afb311831165caaf664602160289a/packages/nuxt/src/app/nuxt.ts#L352
const isNuxtApp =
  ctx && ('$nuxt' in ctx.config.globalProperties || '$nuxt' in ctx.app)

const UiSmartLink: Component = () => {
  let linkComponent: ConcreteComponent | string = 'a'
  let linkAttrs = 'href'

  if (router?.resolve?.(props.to)?.name) {
    linkAttrs = 'to'
    linkComponent = isNuxtApp
      ? resolveComponent('nuxt-link')
      : resolveComponent('router-link')
  }

  const attributes = {
    ...attrs,
    [linkAttrs]: props.to,
    ['data-component-name']:
      typeof linkComponent === 'string' ? linkComponent : linkComponent.name,
  }

  return h(linkComponent, attributes, slots)
}
</script>
